// Generated with util/create-component.js
import Layout from './Layout';

export default Layout;
